/**
 * DevTracker AI Chat Service (Simulated)
 * Provides contextual, keyword-based responses for the DevTracker Assistant.
 */

export const getSimulatedResponse = (message, stats = {}) => {
  const msg = message.toLowerCase();
  const safeStats = stats || {};
  
  // Logic for DNA / Score
  if (msg.includes('dna') || msg.includes('score') || msg.includes('points')) {
    if (!safeStats.score && safeStats.score !== 0) {
      return "I haven't detected your Trust signature yet. Please synchronize your GitHub or LeetCode handles in the 'Platform' tab so I can calculate your score.";
    }
    const score = safeStats.score || 0;
    const classification = safeStats.classification || "Standard Node";
    return `Your current Trust Score is ${score}. This classifies your profile as an "${classification}". To increase your score, consider synchronizing more LeetCode solves or GitHub commits.`;
  }

  // Logic for Synchrony
  if (msg.includes('sync') || msg.includes('synchrony') || msg.includes('stable')) {
    const status = safeStats.status || "Synchronizing";
    return `Platform Synchrony is currently: ${status}. System Backend (DevTracker AI) is monitoring your cross-platform handshakes for any latency.`;
  }

  // Logic for Career / Forecast
  if (msg.includes('career') || msg.includes('job') || msg.includes('market') || msg.includes('senior')) {
    const market = safeStats.marketValue || "Analyzing...";
    return `Based on your technical trajectory, your estimated market resonance is approximately $${market}. You are currently trending towards a "${safeStats.seniority || 'Junior'}" lead position.`;
  }

  // Logic for GitHub / LeetCode / Codeforces
  if (msg.includes('github') || msg.includes('leetcode') || msg.includes('codeforces')) {
    return `I am currently monitoring your activity on ${msg.includes('github') ? 'GitHub' : ''}${msg.includes('leetcode') ? ' LeetCode' : ''}${msg.includes('codeforces') ? ' Codeforces' : ''}. Your latest ingestions are being processed for System Authority verification.`;
  }

  // Logic for SUID / Identity
  if (msg.includes('suid') || msg.includes('private') || msg.includes('support')) {
    return `Your SUID (System Unique ID) is a private invariant used for administrative triage. If you are experiencing technical difficulties, please provide your SUID to a platform moderator.`;
  }

  // Default Professional Responses
  const defaults = [
    "I am DevTracker AI, your system assistant. I can help you analyze your DNA score, platform synchrony, or career trajectory. What would you like to know?",
    "System Backend is online. I'm ready to process your architecture-related queries. How can I assist your development odyssey today?",
    "System Authority verified. I am monitoring your stats in real-time. Ask me about your DNA score or market value forecast.",
    "Data streams are stable. I am ready to provide technical insights into your cross-platform performance."
  ];

  return defaults[Math.floor(Math.random() * defaults.length)];
};
